import commentsOriginalStyling from './CommentsOriginalStyling';

export default [commentsOriginalStyling];
